import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { LocalStorageService } from '../services';
import { StorageService } from '../services/storage.service';
export const preventAuthGuard: CanActivateFn = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  // const preventAuth = inject(LocalStorageService).getDataInLocalStorage('token') ? false : true
  // const preventAuth = inject(StorageService).getToken() ? false : true
  const preventAuth = inject(StorageService).getUserInformation() ? false : true
  console.log(preventAuth);
  return !preventAuth ? inject(Router).navigateByUrl('/') : true
};
